export default __webpack_public_path__ + "static/troll-3e27518d09ddeb1bbcce0166661bd535.webp";